<template>
    <article class="p-v-transition-ud intro" v-if="!is_loading">

        <img src="img/intro_bg.png" alt="" class="intro__bg-hex">
        <img src="img/intro_visual_pc.png" alt="" class="intro__bg-visual u-target-pc _p-iv _p-iv_t">

        <section class="l-section-l intro__content">

            <img src="img/intro_visual_1_sp.png" alt="" class="u-target-sp u-sz-w100-sp _p-iv _p-iv_t" style="margin-bottom:20px;">

            <div class="intro__text-1 _p-iv _p-iv_t _p-iv_dl-2">

                <p>
                    <strong class="intro__strong">The prequel takes place<br class="u-target-pc">two years before “Yuki Yuna is a Hero.”</strong>
                </p>
                <p class="intro__text-1__text">
                    Sixth grader Sumi Washio is a hero chosen by the Divine Tree spirit to protect the world. She fulfills her mission while treasuring each day with her classmates Sonoko Nogi and Gin Minowa.
                </p>
                </p>
            </div>

            <img src="img/intro_visual_2_sp.png" alt="" class="u-target-sp u-sz-w100-sp _p-iv _p-iv_t _p-iv_dl-4">

            <div class="intro__text-2 _p-iv _p-iv_t _p-iv_dl-6">
                <p>
                    <strong class="intro__strong">The story progresses from<br class="u-target-pc">Sumi Washio to Yuki Yuna</strong>
                </p>
                <p class="intro__text-2__text">
                    when an incident disrupts the peaceful existence of the Sanshu Middle School Hero Club…
                </p>
            </div>

            <div class="intro__text-3">
                <p>
                    The TV anime “Yuki Yuna is a Hero – Sumi Washio’s Chapter / The Hero’s Chapter” is a two-part story which bookends the first TV anime “Yuki Yuna is a Hero.” “Sumi Washio’s Chapter” is the prequel and “The Hero’s Chapter” tells the tale of what happens afterwards.
                </p>
            </div>

        </section>
    </article>
</template>


<script>

// 各話データ
import episode_data from '../../js/page/story/episode_data';

export default {
    props: {
        is_loading: Boolean
    },
    created() {
        const urls = ['img/intro_bg.png'];

        if (window.matchMedia("(min-width: 801px)")) {
            urls.push('img/intro_visual_pc.png');
        } else {
            urls.push('img/intro_visual_1_sp.png');
            urls.push('img/intro_visual_2_sp.png');
        }
        episode_data.load_images(urls);
    }
};
</script>




// WEBPACK FOOTER //
// introduction.vue?3633040c